import {triggerDocumentEvent} from "@js/globalFunctions/events";
import {getCookie} from "@js/globalFunctions/cookieHandling";

export function triggerMapLoad(){
	// MAP!
	if($(document).find("#bigMapFetcher").length > 0){

		const type = $(document).find("#bigMapFetcher").attr("data-type");
		const sID = $(document).find("#bigMapFetcher").attr("data-sid");
		const mID = $(document).find("#bigMapFetcher").attr("data-mid");
		const near = $(document).find("#bigMapFetcher").attr("data-near");
		const sqs = $(document).find("#bigMapFetcher").attr("data-sqs");

		if(type === "Search" || type === "Freetext" ){
			fetchGoogleMap(type,null,null,null,sqs);
		}else{
			fetchGoogleMap("Full",sID,mID,near,null);
		}

	}

	if($(document).find("#bigMapFetcherArea").length > 0){
		const type = $(document).find("#bigMapFetcherArea").attr("data-type");
		const mID = $(document).find("#bigMapFetcherArea").attr("data-mid");
		fetchGoogleMap(type,null,mID,null,null);
	}
};

export function fetchGoogleMap(type,sid,mid,near,sqs){
	let queryString = "?";
	if(typeof type !== "undefined" && type != null && type !== ""){queryString += ("type="+type+"&");}
	if(typeof sid !== "undefined" && sid != null && sid !== ""){queryString += ("sID="+sid+"&");}
	if(typeof mid !== "undefined" && mid != null && mid !== ""){queryString += ("mID="+mid+"&");}
	if(typeof near !== "undefined" && near != null && near !== ""){queryString += ("near="+near+"&");}
	if(typeof sqs !== "undefined" && sqs != null && sqs !== ""){queryString += ("sqs="+sqs+"&");}
	if(dataholder.mapHasLoadedOnThisPage === true){queryString += ("ml=true&");}

	if(type === 'Search')
	{
		const arrival = searchParameters.getParameter('ankomst');
		if(arrival !== undefined && arrival.length > 0)
		{
			queryString += 'arrival='+arrival+'&';
			const duration = searchParameters.getParameter('duration');
			if(duration !== undefined && duration.length > 0)
				queryString += 'duration='+duration+'&';
		}
	}

	queryString += ("lan="+siteID);

    addToGoogleMapLog(type,'initial');

	$.ajax({
		url: dataholder.themeUrl + "/includes/googleMapSetup.php" + queryString,
		type: 'POST',
		data: { searchname: getCookie('esbsoldpfp') },
		success:function(data){
			if(dataholder.mapHasLoadedOnThisPage === true){
				$(document).find("#map-wrapper").html(data);
			}else{
				if(type == "SingleLodging"){
					$(document).find("#googleMapFetcher").html(data);
				}else if(type == "Full" || type == "Search" || type == 'Freetext'){
					$(document).find("#bigMapFetcher").html(data);
				}else if(type == "Area"){
					$(document).find("#bigMapFetcherArea").html(data);
				}
			}
			const requiredUpdate = setInterval(function(){
				if($(document).find("#map-canvas").length > 0){
					clearInterval(requiredUpdate);
					triggerDocumentEvent('updateRequiredScripts',{includeCss: true});
				};
			},10)

		}
	});

}
